import { AbstractEntity } from './AbstractEntity'

const DEFAULT_LATITUDE = 46.75
const DEFAULT_LONGITUDE = 2.32

class Entity extends AbstractEntity {
  constructor (
    id = null,
    name = null,
    referent = null,
    mainSite = null,
    country = null,
    area = null,
    citySize = null,
    latitude = DEFAULT_LATITUDE,
    longitude = DEFAULT_LONGITUDE
  ) {
    super(name, referent)
    this.id = id
    this.mainSite = mainSite
    this.country = country
    this.area = area
    this.citySize = citySize
    this.latitude = latitude
    this.longitude = longitude
  }

  toDatabase () {
    return {
      type: 'Entity',
      data: {
        id: this.id,
        name: this.name,
        // don't export referent
        // referent: this.referent,
        mainSite: this.mainSite,
        country: this.country,
        area: this.area,
        citySize: this.citySize,
        latitude: this.latitude,
        longitude: this.longitude
      }
    }
  }

  toString (sep = '\t') {
    return [this.id, this.name, this.mainSite, this.country, this.area].join(
      sep
    )
  }

  static get DEFAULT_LATITUDE () {
    return DEFAULT_LATITUDE
  }

  static get DEFAULT_LONGITUDE () {
    return DEFAULT_LONGITUDE
  }

  static createEmpty () {
    return new Entity()
  }

  static createFromObj (item) {
    return new Entity(
      item.id,
      item.name,
      item.referent,
      item.mainSite,
      item.country,
      item.area,
      item.citySize,
      item.latitude,
      item.longitude
    )
  }

  static exportHeader (sep = '\t') {
    return [
      'entity.id',
      'entity.name',
      'entity.city',
      'entity.country',
      'entity.region'
    ].join(sep)
  }
}

export { Entity }
